import type { Bytes } from "@pdfking/tfunc"

export type BlobType = {
  readonly size: Bytes
  readonly type: string
  readonly slice: (start?: number, end?: number) => BlobType
  readonly arrayBuffer: () => Promise<ArrayBuffer>
}
